import React from "react";
import { useCandidat } from "./useCandidate";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import TextInput from "../../../components/elements/forms/TextInput";
import { Candidate } from "../../../store/types/candidate";
import PhoneInput from "../../../components/elements/forms/PhoneInput";
import FileInputCV from "../../../components/elements/forms/FileUploadCV";

interface CreateCandidateModalProps {
  candidateData?: Candidate | null;
  isEditMode?: boolean;
  onSuccess?: () => void;
}

const CreateCandidateModal: React.FC<CreateCandidateModalProps> = ({
  candidateData,
  isEditMode = false,
  onSuccess,
}) => {
  const { data, error, loading, onChangeHandler, onChangeHandlerBulk, onSubmit, setData } =
    useCandidat(isEditMode, candidateData?.id, onSuccess);
  // const { candidates } = useCandidatess();

  // Initialize form with candidate data in edit mode
  React.useEffect(() => {
    if (isEditMode && candidateData) {
      setData({
        name: candidateData.name || "",
        email: candidateData.email || "",
        phoneNumber: candidateData.phoneNumber || "",
        jobTitle: candidateData.jobTitle || "",
        cv: candidateData.cv || null,
        address: candidateData.address || "",
        id: candidateData.id,
      });
    }
  }, [isEditMode, candidateData]);

  // const handleSubmit = async () => {
  //   if (isEditMode && candidateData?.id) {
  //     // Call update function with candidate ID
  //     // await onSubmit(candidateData.id);
  //   } else {
  //     // Call create function
  //     await onSubmit();
  //   }
  // };

  console.log(data);
  return (
    <div className="">
      <p className="text-20 font-bold mb-3 text-center">
        {isEditMode ? "Edit Candidate" : "Add New Candidate"}
      </p>
      <TextInput
        label="Candidate Name"
        placeholder="Enter first and last name"
        name="name"
        value={data.name}
        status={error.name}
        onChange={onChangeHandler}
        required={!isEditMode}
      />
      <TextInput
        label="Email Address"
        placeholder="Enter email address"
        name="email"
        type="email"
        value={data.email}
        status={error.email}
        onChange={onChangeHandler}
        required={!isEditMode}
      />
      <PhoneInput
        label="Phone Number"
        placeholder="Enter phone number"
        name="phoneNumber"
        value={data.phoneNumber}
        status={error.phoneNumber}
        onChange={onChangeHandler}
        required={!isEditMode}
      />
      <TextInput
        label="Occupation"
        placeholder="Enter occupation"
        name="jobTitle"
        value={data.jobTitle
          ?.replace(/_+/g, " ")
          .toLowerCase()
          ?.replace(/\b\w/g, (char) => char.toUpperCase())}
        status={error.jobTitle}
        onChange={onChangeHandler}
        required={!isEditMode}
      />
      <TextInput
        label="Location"
        placeholder="Enter location"
        name="address"
        value={data.address}
        // status={error.address}
        onChange={onChangeHandler}
        // required={!isEditMode}
      />
      <div>
        <p className="text-15 mb-2">Upload CV</p>
        <div className="flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <FileInputCV
            label="Upload CV"
            name="cv"
            value={data.cvUrl}
            // status={bulkErr.csvFile}
            onChange={onChangeHandlerBulk}
          />
        </div>
      </div>
      <div className="h-[15px]"></div>
      <SubmitButton
        title={isEditMode ? "Update Candidate" : "Create Candidate"}
        onSubmitHandler={onSubmit}
        loading={loading}
        className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
      />
    </div>
  );
};

export default CreateCandidateModal;
